/**
 * [BLURY] | 🥭 App
 * Studio shell: preview stage on the left, control rail on the right.
 * @build 13.09.26
 * @updated 13.09.26 PHT
 * @author TONYTONY Sàrl
 */
import { Rail } from './components/Rail';
import { Stage } from './components/Stage';

export default function App() {
  return (
    <>
      <Stage />
      <Rail />
    </>
  );
}
